import { createFileRoute } from '@tanstack/react-router'

import { PrintSettings } from '#components/features/printing/print-settings'

export const Route = createFileRoute('/_auth/_admin/impressao')({
  head: () => ({
    meta: [
      { title: 'Impressão | UseComanda' },
      {
        name: 'description',
        content: 'Configure a bridge local e a impressora térmica da estação.',
      },
    ],
  }),
  component: RouteComponent,
})

function RouteComponent() {
  return <PrintSettings />
}
